import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMetrodemadridComponent } from './simple-icons-metrodemadrid.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMetrodemadridComponent ],
    exports:      [ SimpleIconsMetrodemadridComponent ],
    bootstrap:    []
})
export class SimpleIconsMetrodemadridModule {}
